import {EventEmitter, Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class SidebarService {

    _hasBackgroundImage = true;
    public sidebarBS = new BehaviorSubject<any>(true);

    constructor() {}

    boards = [{
        name: 'Napravi board',
        hasFunction: true,
        function: 'addNewBoard',
        icon: 'add_to_photos',
        _id: ''
    }];

    data = [
        {
            head: 'Statistika',
            data: [
                {
                    title: 'Filtiranje zadataka',
                    icon: 'search',
                    submenu: false,
                    submenuItems: [],
                    active: true,
                    link: '/timeline'
                },
                {
                    title: 'Moj kalendar',
                    icon: 'calendar_today',
                    submenu: false,
                    submenuItems: [],
                    active: true,
                    link: '/calendar'
                },
                {
                    title: 'Projekti',
                    icon: 'card_travel',
                    submenu: false,
                    submenuItems: [],
                    active: true,
                    link: '/projects'
                },
                {
                    title: 'Slobodni dani – Godišnji odmori',
                    icon: 'edit_calendar',
                    submenu: false,
                    submenuItems: [],
                    active: true,
                    link: '/odmori'
                }
            ],
        }
    ];


    getMenuList() {
        return this.data;
    }

    get hasBackgroundImage() {
        return this._hasBackgroundImage;
    }

    set hasBackgroundImage(hasBackgroundImage) {
        this._hasBackgroundImage = hasBackgroundImage;
    }

    setSideBarBoards(data) {
        this.boards = data;
        this.boards.push(
            {
                name: 'Napravi board',
                hasFunction: true,
                function: 'addNewBoard',
                icon: 'add_to_photos',
                _id: ''
            });

        this.data = [
            {
                head: 'Statistika',
                data: [
                    {
                        title: 'Filtriranje zadataka',
                        icon: 'search',
                        submenu: false,
                        submenuItems: [],
                        active: true,
                        link: '/timeline'
                    },
                    {
                        title: 'Moj kalendar',
                        icon: 'calendar_today',
                        submenu: false,
                        submenuItems: [],
                        active: true,
                        link: '/calendar'
                    },
                    {
                        title: 'Projekti',
                        icon: 'card_travel',
                        submenu: false,
                        submenuItems: [],
                        active: true,
                        link: '/projects'
                    }, {
                        title: 'Backlog',
                        icon: 'layers',
                        submenu: false,
                        submenuItems: [],
                        active: true,
                        link: '/backlog'
                    },
                    {
                        title: 'Aktivni sprint',
                        icon: 'layers',
                        submenu: false,
                        submenuItems: [],
                        active: true,
                        link: '/active-sprint'
                    },
                    {
                        title: 'Slobodni dani – Godišnji odmori',
                        icon: 'edit_calendar',
                        submenu: false,
                        submenuItems: [],
                        active: true,
                        link: '/odmori'
                    }

                ],
            }
        ];
    }

    filter(array: any[], niddle: string) {
        return array.filter(item => item.name.toLowerCase().includes(niddle.toLowerCase()) && item.hasFunction === false);

    }
}
